import { connect } from 'react-redux';

import * as CliApp from 'app/entities/CliApp';
import * as DeveloperActions from 'app/developer-v3/Actions';
import LoadingBlockOrComponent from 'app/common/components/LoadingBlockOrComponent';
import SettingsPage from 'app/developer-v3/pages/settings/SettingsPage';
import hocify from 'app/common/components/hocify';
import {
  currentAppEntity,
  currentAppVersion,
} from 'app/developer-v3/selectors';
import {
  getAppVersionUrl,
  parseBackendAppToAppFormType,
} from 'app/developer-v3/utils';

import type { AppFormType } from 'app/developer-v3/types';

const mapStateToProps = (state, props) => {
  const appEntity = currentAppEntity(state);
  const integrationSettings = appEntity.data
    ? parseBackendAppToAppFormType(appEntity.data)
    : {};
  const appVersion = currentAppVersion(state);
  const baseUrl = getAppVersionUrl(props.params.id, appVersion);
  const isSaving = CliApp.selectors.isSaving(appEntity);
  const isLoading = CliApp.selectors.isLoading(appEntity);
  const isPublished = CliApp.selectors.isPublished(appEntity);

  return {
    cancelUrl: baseUrl,
    initialSettings: {
      appCategory: integrationSettings.app_category,
      appCategoryOther: integrationSettings.app_category_other,
      apiDocsUrl: integrationSettings.api_docs_url,
      description: integrationSettings.description,
      homepageUrl: integrationSettings.homepage_url,
      image: integrationSettings.image,
      intention: integrationSettings.intention,
      primaryColor: integrationSettings.primary_color,
      role: integrationSettings.role,
      subscription: integrationSettings.subscription,
      title: integrationSettings.title,
    },
    isLoading,
    isPublished,
    isSaving,
  };
};

const mapDispatchToProps = (dispatch, props) => ({
  async onLoad() {
    return dispatch(DeveloperActions.getAppFormFields('metaCli'));
  },
  async update(settings: AppFormType) {
    return dispatch(DeveloperActions.updateApp(props.params.id, settings));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(hocify(LoadingBlockOrComponent)(SettingsPage));
